import { render } from "./organization-lookup.vue?vue&type=template&id=dd9e3c7e"
import script from "./organization-lookup.vue?vue&type=script&lang=js"
export * from "./organization-lookup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__